import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserSideRoutingModule } from './user-side-routing.module';
import { UserAlarmEventsComponent } from './user-alarm-events/user-alarm-events.component';
import { UserAlarmAccidentComponent } from './user-alarm-accident/user-alarm-accident.component';
import { ReportComponent } from './report/report.component';
import { AddFavorisReportComponent } from './add-favoris-report/add-favoris-report.component';
import { PlannificationReportComponent } from './plannification-report/plannification-report.component';
import { ReportHistoryComponent } from './report-history/report-history.component';
import { UserVehiculeDetailsContainerComponent } from './user-vehicle/user-vehicule-details/user-vehicule-details-container/user-vehicule-details-container.component';
import { UserVehiculeDetailsEventsComponent } from './user-vehicle/user-vehicule-details/user-vehicule-details-events/user-vehicule-details-events.component';
import { UserVehiculeDetailsScoresComponent } from './user-vehicle/user-vehicule-details/user-vehicule-details-scores/user-vehicule-details-scores.component';
import { UserVehiculeDetComponent } from './user-vehicle/user-vehicule-details/user-vehicule-det/user-vehicule-det.component';
import { UserAlarmComponent } from './user-alarm/user-alarm.component';
import { UserConducteurComponent } from './user-conducteur/user-conducteur/user-conducteur.component';
import { UserConducteurDetailsComponent } from './user-conducteur/user-conducteur-details/user-conducteur-details.component';
import { UserConducteurTrajetComponent } from './user-conducteur/user-conducteur-trajet/user-conducteur-trajet.component';
import { EventsComponent } from './events/events/events.component';
import { ContactComponent } from './contact/contact.component';
import { HistoriqueAlarmComponent } from './historique-alarm/historique-alarm.component';
import { UserCoreFooterComponent } from './user-core/user-core-footer/user-core-footer.component';
import { DownloadRapportComponent } from './download-rapport/download-rapport.component';
 


@NgModule({
  declarations: [DownloadRapportComponent],
  imports: [
    CommonModule,
    UserSideRoutingModule
  ],
 })
export class UserSideModule { }
